// One-shot native bootstrap. Imported from main.jsx. No-ops on web.

import { Capacitor } from '@capacitor/core';

function isNative() {
  try { return Capacitor.isNativePlatform(); } catch { return false; }
}

export async function initNative() {
  if (!isNative()) return;

  // Splash: hide once the app has rendered (we keep the launch screen up
  // for ~1.5s via capacitor.config; this call is the safety net).
  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide({ fadeOutDuration: 200 });
  } catch {}

  // Status bar: match our app background so it doesn't look detached.
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setStyle({ style: Style.Default });
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#fbf7f2' });
    }
  } catch {}

  // Back button on Android: leave the lesson instead of closing the app.
  // The router state lives in React, but exposing a 'ballingo:back' event
  // is the cleanest way to let the App component decide what to do.
  try {
    const { App } = await import('@capacitor/app');
    App.addListener('backButton', () => {
      const handled = window.dispatchEvent(
        new CustomEvent('ballingo:back', { cancelable: true })
      );
      if (!handled) App.exitApp();
    });
  } catch {}
}
